import * as React from 'react';
const SvgHackerearth = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="18" height="18" rx="4.5" fill="#020109" />
    <path
      d="M12.9264 16.2334H5.07385V14.8535H12.9264V16.2334ZM6.99768 5.73828C7.22282 5.3975 7.49219 5.1213 7.8053 4.91016C8.29771 4.56664 8.88167 4.39454 9.55725 4.39453C10.5879 4.39453 11.39 4.71517 11.9625 5.35645C12.535 5.98619 12.8209 6.95973 12.8209 8.27637V13.1895H10.8971V8.79199C10.8971 8.10507 10.8171 7.5783 10.6569 7.21191C10.4966 6.83413 10.2731 6.57079 9.98694 6.42188C9.71217 6.27302 9.39135 6.19827 9.02502 6.19824C8.37231 6.18677 7.86831 6.39887 7.51331 6.83398C7.16979 7.26908 6.99771 7.89313 6.99768 8.70605V13.1895H5.07385V0H6.99768V5.73828Z"
      fill="white"
    />
  </svg>
);
export default SvgHackerearth;
